import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-achievements-page',
  templateUrl: './achievements-page.component.html',
  styleUrls: ['./achievements-page.component.scss']
})
export class AchievementsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
